export const diffItems = <T>(
  oldItems: T[],
  newItems: T[],
  getKey: (item: T) => string,
): { added: T[]; removed: T[] } => {
  const oldKeys = new Set(oldItems.map(getKey));
  const newKeys = new Set(newItems.map(getKey));
  return {
    added: newItems.filter(item => !oldKeys.has(getKey(item))),
    removed: oldItems.filter(item => !newKeys.has(getKey(item))),
  };
};
